export default function findNonTierLayersIds(allLayers, lastLayerIdFromTiers) {
    if (!allLayers.length) {
        return [];
    }

    let currentLayerIndex = -1;
    let firstNonTierLayerIndex = 0;
    if (lastLayerIdFromTiers.length) {
        lastLayerIdFromTiers = lastLayerIdFromTiers.slice().reverse();
        currentLayerIndex = allLayers.length;
        while (currentLayerIndex > 0) {
            currentLayerIndex = currentLayerIndex - 1;
            const currentLayer = allLayers[currentLayerIndex];
            if (lastLayerIdFromTiers.indexOf(currentLayer.id) !== -1) {
                firstNonTierLayerIndex = currentLayerIndex + 1;
                break;
            }
        }
    }

    return allLayers.slice(firstNonTierLayerIndex).map(layer => layer.id);
}



// WEBPACK FOOTER //
// ./map/tier/styleUpdate/findNonTierLayersIds.js